module.exports = __webpack_public_path__ + "static/img/7.fe106ca.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/dhlw/7.png
// module id = z/an
// module chunks = 0